import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody
} from "reactstrap";
import axios from "axios";
import useFetchUserMe from "../hooks/useFetchUserMe";
import { Enviroments } from "../enviroments/enviroments";

const Withdraw = () => {
  const { data: userMe, loading, error } = useFetchUserMe();
  const [selectedKey, setSelectedKey] = useState("CPF");
  const [keyValue, setKeyValue] = useState("");
  const [withdrawValue, setWithdrawValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const [showAddressForm, setShowAddressForm] = useState(false);
  // Estado do formulário de endereço
  const [cep, setCep] = useState("");
  const [estado, setEstado] = useState("");
  const [cidade, setCidade] = useState("");
  const [rua, setRua] = useState("");
  const [bairro, setBairro] = useState("");
  const [numero, setNumero] = useState("");

  useEffect(() => {
    if (userMe) {
      setKeyValue(userMe?.document?.number || "");
      setCep(userMe?.zipCode || "");
      setEstado(userMe?.state || "");
      setCidade(userMe?.city || "");
      setRua(userMe?.street || "");
      setBairro(userMe?.neighborhood || "");
      setNumero(userMe?.number || "");
    }
  }, [userMe]);

  const handleKeyChange = e => {
    setSelectedKey(e.target.value);
    switch (e.target.value) {
      case "CPF":
        setKeyValue(userMe?.document?.number || "");
        break;
      case "Telefone":
        setKeyValue(userMe?.phone || "");
        break;
      case "Email":
        setKeyValue(userMe?.email || "");
        break;
      default:
        setKeyValue("");
    }
  };

  const fetchAddress = async cep => {
    if (cep.length !== 8) return;
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json`);
      if (response.data) {
        setEstado(response.data.uf);
        setCidade(response.data.localidade);
        setRua(response.data.logradouro);
        setBairro(response.data.bairro);
      }
    } catch (err) {
      console.error("Erro ao buscar CEP:", err);
      setErrorMessage("CEP inválido. Verifique e tente novamente.");
    }
  };

  const handleSubmitAddress = async () => {
    if (!cep || !numero) {
      setErrorMessage("Preencha o CEP e o Número corretamente.");
      return;
    }

    try {
      const apiToken = localStorage.getItem("apiToken");

      const payload = {
        id: userMe?.id,
        name: userMe?.name,
        document: userMe?.document,
        email: userMe?.email,
        phone: userMe?.phone,
        nationality: userMe?.nationality || "Brasileiro",
        gender: userMe?.gender || 1,
        birthDate: userMe?.birthDate,
        created_at: userMe?.created_at,
        status: userMe?.status,
        state: estado,
        zipCode: cep,
        number: numero,
        city: cidade,
        street: rua,
        neighborhood: bairro
      };

      await axios.post("https://lotogreen.bet.br/api/userUpdate", payload, {
        headers: {
          Authorization: `Bearer ${apiToken}`,
          "Content-Type": "application/json"
        }
      });

      setSuccessMessage(
        "Endereço atualizado com sucesso! Agora você pode sacar."
      );
      setShowAddressForm(false); // Oculta o formulário para permitir o saque
    } catch (err) {
      console.error("Erro ao atualizar endereço:", err);
      setErrorMessage(
        "Erro ao atualizar endereço. Tente novamente. Recarrega a página."
      );
    }
  };

  const handleWithdraw = async () => {
    setErrorMessage("");
    setSuccessMessage("");

    if (!withdrawValue) {
      setErrorMessage("Por favor, insira um valor para saque.");
      return;
    }

    if (parseFloat(withdrawValue) < 30) {
      setErrorMessage("O valor mínimo para saque é R$ 30,00.");
      return;
    }

    try {
      const apiToken = localStorage.getItem("apiToken");
      const payload = {
        amount: parseFloat(withdrawValue) * 100,
        pixType: selectedKey,
        pixKey: keyValue
      };

      const response = await axios.post(
        `${Enviroments.API_URL_LOTOGREEN}api/withdraws`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${apiToken}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data && response.data.success) {
        setSuccessMessage("Saque solicitado com sucesso!");
        setWithdrawValue("");
      } else {
        if (
          response.data.message ===
          "Você precisa preencher o endereço antes de conseguir sacar o dinheiro."
        ) {
          setShowAddressForm(true);
        } else {
          setErrorMessage(
            response.data.message || "Erro ao processar o saque."
          );
        }
      }
    } catch (err) {
      console.error("Erro ao solicitar saque:", err);
      setErrorMessage(
        "Erro ao processar o saque. Tente novamente. Motivo:" +
          err?.response?.data?.message
      );
    }
  };

  const handleFacial = async () => {
    try {
      // Primeira requisição: Criar sessão de verificação facial
      const faceVerifyResponse = await axios.post(
        "https://api-aviator-new-e377b0de89f5.herokuapp.com/kyc/session",
        {
          cpf: userMe?.document?.number,
          token: "acbb65eb-3aaa-4933-be30-4e92f07cbec6",
          flow: "kyc-faceindex",
          betHouse: "lotogreen"
        }
      );

      if (faceVerifyResponse.data?.session_id) {
        setSessionId(faceVerifyResponse.data.session_id);
        setModalOpen(true);
      } else {
        setErrorMessage("Erro ao iniciar verificação facial. Tente novamente.");
      }
    } catch (err) {
      console.error("Erro ao iniciar verificação facial:", err);
      setErrorMessage("Erro ao iniciar verificação facial. Tente novamente.");
    }
  };

  if (loading) return <p>Carregando...</p>;
  if (error) return <p>Erro ao carregar os dados do usuário.</p>;

  return (
    <Container className="content mt-5 mb-5">
      <Row>
        <Col md={{ size: 6, offset: 3 }}>
          <div className="text-center mb-4">
            <h4 className="text-white">Saque</h4>
            <p className="text-muted">
              Para realizar o saque, acesse diretamente a plataforma EsportivaBet:
            </p>
            <a 
              href="https://go.aff.esportiva.bet/bffv8o29" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-success btn-lg mt-2"
            >
              Acessar Plataforma para Saque
            </a>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Withdraw;
